module.exports = __webpack_public_path__ + "static/image-02-a@2x-f4472de86b006d313e998d2b08fe8d09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/yieldr/image-02-a@2x.jpg
// module id = 426
// module chunks = 3627797113349 20562973939449 33019919093843